import script from "./login-terms-conditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./login-terms-conditions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__